import React from 'react'
import '../App.css'

export const Loading = () => {
  return <div className='loading'>Loading...</div>
}
